// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expertiseContainer {
  width: 100%;
  background-color: #fdf1e3;
  padding: 60px 24px 70px;
}

.expertiseHeading {
  font-weight: 800;
  color: #172639;
  letter-spacing: 0.5px;
}

.expertiseUnderline {
  width: 90px;
  height: 3px;
  background-color: #eaa637;
  margin: 12px auto 40px;
}

.expertiseCards {
  max-width: 1200px;
  margin: 0 auto;
}

.expertiseCard {
  background-color: #ffffff;
  border: 1px solid #ececec;
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);
  padding: 28px 26px;
  height: 100%;
}

.expertiseIconBox {
  width: 56px;
  height: 56px;
  background-color: #172639;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  color: #eaa637;
  font-size: 22px;
}

.expertiseCardTitle {
  font-weight: 700;
  color: #172639;
  margin-bottom: 12px;
}

.expertiseCardText {
  color: #555555;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .expertiseContainer {
    padding: 40px 16px 50px;
  }

  .expertiseHeading {
    font-size: 1.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OurExpertise.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".expertiseContainer {\n  width: 100%;\n  background-color: #fdf1e3;\n  padding: 60px 24px 70px;\n}\n\n.expertiseHeading {\n  font-weight: 800;\n  color: #172639;\n  letter-spacing: 0.5px;\n}\n\n.expertiseUnderline {\n  width: 90px;\n  height: 3px;\n  background-color: #eaa637;\n  margin: 12px auto 40px;\n}\n\n.expertiseCards {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.expertiseCard {\n  background-color: #ffffff;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);\n  padding: 28px 26px;\n  height: 100%;\n}\n\n.expertiseIconBox {\n  width: 56px;\n  height: 56px;\n  background-color: #172639;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n  color: #eaa637;\n  font-size: 22px;\n}\n\n.expertiseCardTitle {\n  font-weight: 700;\n  color: #172639;\n  margin-bottom: 12px;\n}\n\n.expertiseCardText {\n  color: #555555;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  margin-bottom: 0;\n}\n\n@media (max-width: 768px) {\n  .expertiseContainer {\n    padding: 40px 16px 50px;\n  }\n\n  .expertiseHeading {\n    font-size: 1.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
